import React from 'react';
import Search from './Search';
import './App.css';

function App() {
  return (
    <div className="App">
      <Search />
    </div>
  );
}

export default App;
